// extracted by mini-css-extract-plugin
module.exports = {"title":"Label_title__hCPqX","subTitle":"Label_subTitle__w7n1-","text":"Label_text__3JpWx"};